import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { TimeZoneStrategyType } from 'automation-ui-flow-core/fields/time/TimeZoneStrategy';
import getTimeDelayFormatOptions from 'automation-ui-action-features/actions/delay/utils/getTimeDelayFormatOptions';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DelayActionExplainer({
  action
}) {
  const {
    delay
  } = action.metadata;
  const {
    daysOfWeek,
    timeOfDay,
    optionalTimeZoneStrategy
  } = delay;
  const isUsingObjectTimezone = optionalTimeZoneStrategy && optionalTimeZoneStrategy.type === TimeZoneStrategyType.ENROLLED_OBJECT;
  let messageKey;
  if (!daysOfWeek.isEmpty() && timeOfDay) {
    if (isUsingObjectTimezone) {
      messageKey = 'automation-ui-action-features.action-features.delay.explainer.dayAndTime.inObjectTimezone';
    } else {
      messageKey = 'automation-ui-action-features.action-features.delay.explainer.dayAndTime.inStaticTimezone';
    }
  } else if (!daysOfWeek.isEmpty()) {
    messageKey = 'automation-ui-action-features.action-features.delay.explainer.dayOfWeek';
  } else if (timeOfDay) {
    if (isUsingObjectTimezone) {
      messageKey = 'automation-ui-action-features.action-features.delay.explainer.timeOfDay.inObjectTimezone';
    } else {
      messageKey = 'automation-ui-action-features.action-features.delay.explainer.timeOfDay.inStaticTimezone';
    }
  } else {
    messageKey = 'automation-ui-action-features.action-features.delay.explainer.duration';
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: messageKey,
    options: getTimeDelayFormatOptions(delay)
  });
}